import XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export function excelExport(reportData, reportName, precision) {
  const { input, Numerical_Results: numericalResults } = reportData.tm30;
  let dataArray = [];
  let dataObj;
  let initialWaveLength = 379;
  input.SPD.forEach((data) => {
    initialWaveLength = initialWaveLength + 1;

    dataObj = {
      Wavelength: initialWaveLength,
      SPD: precision === 'rounded' ? data.toFixed(4) : data,
    };
    dataArray.push(dataObj);
  });

  if (dataArray.length < 401) {
    const fillEmpty = 401 - dataArray.length;
    for (let i = dataArray.length; i <= fillEmpty; i++) {
      dataObj = {
        Wavelength: '',
        SPD: '',
      };
      dataArray.push(dataObj);
    }
  }

  //CCT
  Object.assign(dataArray[0], {
    'CCT (K)':
      precision === 'rounded'
        ? Math.round(numericalResults.CCT[0])
        : numericalResults.CCT[0],
  });
  //DUV
  //   const duv = `D${"uv".sub()}`;
  Object.assign(dataArray[0], {
    Duv:
      precision === 'rounded'
        ? numericalResults.DUV[0].toFixed(4)
        : numericalResults.DUV[0],
  });
  //u
  Object.assign(dataArray[0], {
    "u'":
      precision === 'rounded'
        ? numericalResults.u[0].toFixed(4)
        : numericalResults.u[0],
  });
  //v
  Object.assign(dataArray[0], {
    "v'":
      precision === 'rounded'
        ? numericalResults.v[0].toFixed(4)
        : numericalResults.v[0],
  });
  //rf
  Object.assign(dataArray[0], {
    Rf:
      precision === 'rounded'
        ? Math.round(numericalResults.rf)
        : numericalResults.rf,
  });
  //rg
  Object.assign(dataArray[0], {
    Rg:
      precision === 'rounded'
        ? Math.round(numericalResults.rg)
        : numericalResults.rg,
  });
  //   //LER
  //   Object.assign(dataArray[0], {
  //     LER: numericalResults.LER[0]
  //   });
  //Hue_angle_bin
  numericalResults.local_chroma_shift.forEach((value, index) => {
    Object.assign(dataArray[index], {
      'Hue-Angle Bin (j)': index + 1,
    });
  });
  //local_chroma_shift
  numericalResults.local_chroma_shift.forEach((value, index) => {
    Object.assign(dataArray[index], {
      'Local Chroma Shift (Rcs,hj)': `${
        precision === 'rounded' ? Math.round(value) : value
      }%`,
    });
  });
  //local_hue_shift
  numericalResults.local_hue_shift.forEach((value, index) => {
    Object.assign(dataArray[index], {
      'Local Hue Shift (Rhs,hj)':
        precision === 'rounded' ? value.toFixed(2) : value,
    });
  });
  //local_color_fidelity
  numericalResults.local_color_fidelity.forEach((value, index) => {
    Object.assign(dataArray[index], {
      'Local Color Fidelity (Rf,hj)':
        precision === 'rounded' ? Math.round(value) : value,
    });
  });
  //sample_count
  numericalResults.sample_count.forEach((value, index) => {
    Object.assign(dataArray[index], {
      'Sample Count (m)': precision === 'rounded' ? Math.round(value) : value,
    });
  });
  //a_prime_test_j
  numericalResults.a_prime_test_j.forEach((value, index) => {
    Object.assign(dataArray[index], {
      "a'test,j": precision === 'rounded' ? value.toFixed(2) : value,
    });
  });
  //b_prime_test_j
  numericalResults.b_prime_test_j.forEach((value, index) => {
    Object.assign(dataArray[index], {
      "b'test,j": precision === 'rounded' ? value.toFixed(2) : value,
    });
  });
  //a_prime_ref_j
  numericalResults.a_prime_ref_j.forEach((value, index) => {
    Object.assign(dataArray[index], {
      "a'ref,j": precision === 'rounded' ? value.toFixed(2) : value,
    });
  });
  //b_prime_ref_j
  numericalResults.b_prime_ref_j.forEach((value, index) => {
    Object.assign(dataArray[index], {
      "b'ref,j": precision === 'rounded' ? value.toFixed(2) : value,
    });
  });
  //da_relative
  numericalResults.da_relative.forEach((value, index) => {
    Object.assign(dataArray[index], {
      da_relative: precision === 'rounded' ? value.toFixed(2) : value,
    });
  });
  //db_relative
  numericalResults.db_relative.forEach((value, index) => {
    Object.assign(dataArray[index], {
      db_relative: precision === 'rounded' ? value.toFixed(2) : value,
    });
  });
  //path_xtest
  numericalResults.path_xtest.forEach((value, index) => {
    Object.assign(dataArray[index], {
      path_xtest: precision === 'rounded' ? value.toFixed(2) : value,
    });
  });
  //path_ytest
  numericalResults.path_ytest.forEach((value, index) => {
    Object.assign(dataArray[index], {
      path_ytest: precision === 'rounded' ? value.toFixed(2) : value,
    });
  });
  //path_xref
  numericalResults.path_xref.forEach((value, index) => {
    Object.assign(dataArray[index], {
      path_xref: precision === 'rounded' ? value.toFixed(2) : value,
    });
  });
  //path_yref
  numericalResults.path_yref.forEach((value, index) => {
    Object.assign(dataArray[index], {
      path_yref: precision === 'rounded' ? value.toFixed(2) : value,
    });
  });
  //sample
  numericalResults.color_sample_fidelity.forEach((value, index) => {
    Object.assign(dataArray[index], {
      'Sample (i)': index + 1,
    });
  });
  //color_sample_fidelity
  numericalResults.color_sample_fidelity.forEach((value, index) => {
    Object.assign(dataArray[index], {
      'Sample Color Fidelity (SCF)':
        precision === 'rounded' ? Math.round(value) : value,
    });
  });
  //j_test_coordinates
  numericalResults.j_test_coordinates.forEach((value, index) => {
    Object.assign(dataArray[index], {
      "j't,i": precision === 'rounded' ? value.toFixed(2) : value,
    });
  });
  //a_test_coordinates
  numericalResults.a_test_coordinates.forEach((value, index) => {
    Object.assign(dataArray[index], {
      "a't,i": precision === 'rounded' ? value.toFixed(2) : value,
    });
  });

  //b_test_coordinates
  numericalResults.b_test_coordinates.forEach((value, index) => {
    Object.assign(dataArray[index], {
      "b't,i": precision === 'rounded' ? value.toFixed(2) : value,
    });
  });
  //j_ref_coordinates
  numericalResults.j_ref_coordinates.forEach((value, index) => {
    Object.assign(dataArray[index], {
      "j'r,i": precision === 'rounded' ? value.toFixed(2) : value,
    });
  });
  //a_ref_coordinates
  numericalResults.a_ref_coordinates.forEach((value, index) => {
    Object.assign(dataArray[index], {
      "a'r,i": precision === 'rounded' ? value.toFixed(2) : value,
    });
  });

  //b_ref_coordinates
  numericalResults.b_ref_coordinates.forEach((value, index) => {
    Object.assign(dataArray[index], {
      "b'r,i": precision === 'rounded' ? value.toFixed(2) : value,
    });
  });

  //hue_angle_bin
  numericalResults.hue_angle_bin.forEach((value, index) => {
    Object.assign(dataArray[index], {
      'Hue-Angle-Bin (j)': value,
    });
  });

  //   //normalized_SPD_test
  //   numericalResults.normalized_SPD_test.forEach((value, index) => {
  //     Object.assign(dataArray[index], {
  //       normalized_SPD_test: value
  //     });
  //   });

  //   //x
  //   Object.assign(dataArray[0], {
  //     x: numericalResults.x[0]
  //   });
  //   //y
  //   Object.assign(dataArray[0], {
  //     y: numericalResults.y[0]
  //   });

  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const ws = XLSX.utils.json_to_sheet(dataArray);

  let wscols = [
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 20 },
    { wch: 25 },
    { wch: 20 },
    { wch: 25 },
    { wch: 15 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 20 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 15 },
  ];
  //   wsKeys.forEach(key => {
  //     if (ws[key].t === "s") {
  //       //   if (ws[key].v.length > 10) {
  //       //     wscols.push({ wch: 20 });
  //       //   }
  //       //   else {
  //       //     wscols.push({ wch: 10 });
  //       //   }
  //       Object.assign(ws[key], {
  //         r: "Test",
  //         w: "Test",
  //         h: "Test<span><sub>Test</sub></span>"
  //         // s: {
  //         //   font: {
  //         //     bold: true
  //         //   }
  //         // }
  //       });
  //     }
  //   });
  // Object.assign(ws["A3"], {
  //   bold: true
  // });
  // ws["A3"].l = {
  //   Target: "http://sheetjs.com",
  //   Tooltip: "Find us @ SheetJS.com!"
  // };

  ws['!cols'] = wscols;
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: fileType });
  saveAs(data, reportName + fileExtension);
}
